export default __webpack_public_path__ + "static/media/ground.c88b21d0.svg";